// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"1427":"8e70889b","1637":"5bda4a79","3207":"64e73bfa","3882":"56b178da","7142":"f0a39469"}[chunkId] + ".js";
};